import type { BaseController } from '@infra/controllers/base.controller';
import type { DialNumberUsecase } from '@usecases/dial-number.usecase';

export type DialNumberInput = {
  callId: string;
  phoneNumber: string;
};

export type DialNumberOutput = void;

export class DialNumberController
  implements BaseController<DialNumberInput, DialNumberOutput>
{
  constructor(private usecase: DialNumberUsecase) {}

  async handle({
    callId,
    phoneNumber: to,
  }: DialNumberInput): Promise<DialNumberOutput> {
    await this.usecase.run({ callId, to });
  }
}
